import ProposalSpaces from "./ProposalSpaces";

export default ProposalSpaces;
